__turbopack_context__.v({
  "description": "FilterPanel-module-scss-module__BHwbmG__description",
  "drawer": "FilterPanel-module-scss-module__BHwbmG__drawer",
  "groups": "FilterPanel-module-scss-module__BHwbmG__groups",
  "leading": "FilterPanel-module-scss-module__BHwbmG__leading",
  "panel": "FilterPanel-module-scss-module__BHwbmG__panel",
  "range": "FilterPanel-module-scss-module__BHwbmG__range",
  "section": "FilterPanel-module-scss-module__BHwbmG__section",
  "title": "FilterPanel-module-scss-module__BHwbmG__title",
  "values": "FilterPanel-module-scss-module__BHwbmG__values",
});
